/**-----------------------------------------------------------------------------------------
* Copyright © 2025 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
var setData = require('@progress/kendo-angular-intl').setData;
setData({
  name: "fi",
  identity: {
    language: "fi"
  },
  territory: "FI",
  numbers: {
    symbols: {
      decimal: ",",
      group: " ",
      list: ";",
      percentSign: "%",
      plusSign: "+",
      minusSign: "−",
      approximatelySign: "~",
      exponential: "E",
      superscriptingExponent: "×",
      perMille: "‰",
      infinity: "∞",
      nan: "epäluku",
      timeSeparator: "."
    },
    decimal: {
      patterns: ["n"],
      groupSize: [3]
    },
    scientific: {
      patterns: ["nEn"],
      groupSize: []
    },
    percent: {
      patterns: ["n %"],
      groupSize: [3]
    },
    currency: {
      patterns: ["n $"],
      groupSize: [3],
      "unitPattern-count-one": "n $",
      "unitPattern-count-other": "n $"
    },
    accounting: {
      patterns: ["n $"],
      groupSize: [3]
    },
    currencies: {
      ADP: {
        displayName: "Andorran peseta",
        "displayName-count-one": "Andorran peseta",
        "displayName-count-other": "Andorran pesetaa",
        symbol: "ADP"
      },
      AED: {
        displayName: "Arabiemiirikuntien dirhami",
        "displayName-count-one": "Arabiemiirikuntien dirhami",
        "displayName-count-other": "Arabiemiirikuntien dirhamia",
        symbol: "AED"
      },
      AFA: {
        displayName: "Afganistanin afgaani (1927–2002)",
        "displayName-count-one": "Afganistanin afgaani (1927–2002)",
        "displayName-count-other": "Afganistanin afgaania (1927–2002)",
        symbol: "AFA"
      },
      AFN: {
        displayName: "Afganistanin afgaani",
        "displayName-count-one": "Afganistanin afgaani",
        "displayName-count-other": "Afganistanin afgaania",
        symbol: "AFN",
        "symbol-alt-narrow": "؋"
      },
      ALK: {
        displayName: "Albanian lek (1946–1965)",
        "displayName-count-one": "Albanian lek (1946–1965)",
        "displayName-count-other": "Albanian lekiä (1946–1965)",
        symbol: "ALK"
      },
      ALL: {
        displayName: "Albanian lek",
        "displayName-count-one": "Albanian lek",
        "displayName-count-other": "Albanian lekiä",
        symbol: "ALL"
      },
      AMD: {
        displayName: "Armenian dram",
        "displayName-count-one": "Armenian dram",
        "displayName-count-other": "Armenian dramia",
        symbol: "AMD",
        "symbol-alt-narrow": "֏"
      },
      ANG: {
        displayName: "Alankomaiden Antillien guldeni",
        "displayName-count-one": "Alankomaiden Antillien guldeni",
        "displayName-count-other": "Alankomaiden Antillien guldenia",
        symbol: "ANG"
      },
      AOA: {
        displayName: "Angolan kwanza",
        "displayName-count-one": "Angolan kwanza",
        "displayName-count-other": "Angolan kwanzaa",
        symbol: "AOA",
        "symbol-alt-narrow": "AOA"
      },
      AOK: {
        displayName: "Angolan kwanza (1977–1991)",
        "displayName-count-one": "Angolan kwanza (1977–1990)",
        "displayName-count-other": "Angolan kwanzaa (1977–1990)",
        symbol: "AOK"
      },
      AON: {
        displayName: "Angolan uusi kwanza (1990–2000)",
        "displayName-count-one": "Angolan uusi kwanza (1990–2000)",
        "displayName-count-other": "Angolan uutta kwanzaa (1990–2000)",
        symbol: "AON"
      },
      AOR: {
        displayName: "Angolan kwanza reajustado (1995–1999)",
        "displayName-count-one": "Angolan kwanza reajustado (1995–1999)",
        "displayName-count-other": "Angolan kwanza reajustadoa (1995–1999)",
        symbol: "AOR"
      },
      ARA: {
        displayName: "Argentiinan austral",
        "displayName-count-one": "Argentiinan austral",
        "displayName-count-other": "Argentiinan australia",
        symbol: "ARA"
      },
      ARL: {
        displayName: "Argentiinan ley-peso (1970–1983)",
        "displayName-count-one": "Argentiinan ley-peso (1970–1983)",
        "displayName-count-other": "Argentiinan ley-pesoa (1970–1983)",
        symbol: "ARL"
      },
      ARM: {
        displayName: "Argentiinan peso (1881–1970)",
        "displayName-count-one": "Argentiinan peso (1881–1970)",
        "displayName-count-other": "Argentiinan pesoa (1881–1970)",
        symbol: "ARM"
      },
      ARP: {
        displayName: "Argentiinan peso (1983–1985)",
        "displayName-count-one": "Argentiinan peso (1983–1985)",
        "displayName-count-other": "Argentiinan pesoa (1983–1985)",
        symbol: "ARP"
      },
      ARS: {
        displayName: "Argentiinan peso",
        "displayName-count-one": "Argentiinan peso",
        "displayName-count-other": "Argentiinan pesoa",
        symbol: "ARS",
        "symbol-alt-narrow": "ARS"
      },
      ATS: {
        displayName: "Itävallan šillinki",
        "displayName-count-one": "Itävallan šillinki",
        "displayName-count-other": "Itävallan šillinkiä",
        symbol: "ATS"
      },
      AUD: {
        displayName: "Australian dollari",
        "displayName-count-one": "Australian dollari",
        "displayName-count-other": "Australian dollaria",
        symbol: "AUD",
        "symbol-alt-narrow": "AUD"
      },
      AWG: {
        displayName: "Aruban floriini",
        "displayName-count-one": "Aruban floriini",
        "displayName-count-other": "Aruban floriinia",
        symbol: "AWG"
      },
      AZM: {
        displayName: "Azerbaidžanin manat (1993–2006)",
        "displayName-count-one": "Azerbaidžanin manat (1993–2006)",
        "displayName-count-other": "Azerbaidžanin manatia (1993–2006)",
        symbol: "AZM"
      },
      AZN: {
        displayName: "Azerbaidžanin manat",
        "displayName-count-one": "Azerbaidžanin manat",
        "displayName-count-other": "Azerbaidžanin manatia",
        symbol: "AZN",
        "symbol-alt-narrow": "₼"
      },
      BAD: {
        displayName: "Bosnia-Hertsegovinan dinaari (1992–1994)",
        "displayName-count-one": "Bosnia-Hertsegovinan dinaari (1992–1994)",
        "displayName-count-other": "Bosnia-Hertsegovinan dinaaria (1992–1994)",
        symbol: "BAD"
      },
      BAM: {
        displayName: "Bosnia-Hertsegovinan vaihdettava markka",
        "displayName-count-one": "Bosnia-Hertsegovinan vaihdettava markka",
        "displayName-count-other": "Bosnia-Hertsegovinan vaihdettavaa markkaa",
        symbol: "BAM",
        "symbol-alt-narrow": "BAM"
      },
      BAN: {
        displayName: "Bosnia-Hertsegovinan uusi dinaari (1994–1997)",
        "displayName-count-one": "Bosnia-Hertsegovinan uusi dinaari (1994–1997)",
        "displayName-count-other": "Bosnia-Hertsegovinan uutta dinaaria (1994–1997)",
        symbol: "BAN"
      },
      BBD: {
        displayName: "Barbadosin dollari",
        "displayName-count-one": "Barbadosin dollari",
        "displayName-count-other": "Barbadosin dollaria",
        symbol: "BBD",
        "symbol-alt-narrow": "BBD"
      },
      BDT: {
        displayName: "Bangladeshin taka",
        "displayName-count-one": "Bangladeshin taka",
        "displayName-count-other": "Bangladeshin takaa",
        symbol: "BDT",
        "symbol-alt-narrow": "BDT"
      },
      BEC: {
        displayName: "Belgian vaihdettava frangi",
        "displayName-count-one": "Belgian vaihdettava frangi",
        "displayName-count-other": "Belgian vaihdettavaa frangia",
        symbol: "BEC"
      },
      BEF: {
        displayName: "Belgian frangi",
        "displayName-count-one": "Belgian frangi",
        "displayName-count-other": "Belgian frangia",
        symbol: "BEF"
      },
      BEL: {
        displayName: "Belgian rahoitusfrangi",
        "displayName-count-one": "Belgian rahoitusfrangi",
        "displayName-count-other": "Belgian rahoitusfrangia",
        symbol: "BEL"
      },
      BGL: {
        displayName: "Bulgarian kova lev",
        "displayName-count-one": "Bulgarian kova lev",
        "displayName-count-other": "Bulgarian kovaa leviä",
        symbol: "BGL"
      },
      BGM: {
        displayName: "Bulgarian sosialistinen lev",
        "displayName-count-one": "Bulgarian sosialistinen lev",
        "displayName-count-other": "Bulgarian sosialistista leviä",
        symbol: "BGM"
      },
      BGN: {
        displayName: "Bulgarian lev",
        "displayName-count-one": "Bulgarian lev",
        "displayName-count-other": "Bulgarian leviä",
        symbol: "BGN"
      },
      BGO: {
        displayName: "Bulgarian lev (1879–1952)",
        "displayName-count-one": "Bulgarian lev (1879–1952)",
        "displayName-count-other": "Bulgarian leviä (1879–1952)",
        symbol: "BGO"
      },
      BHD: {
        displayName: "Bahrainin dinaari",
        "displayName-count-one": "Bahrainin dinaari",
        "displayName-count-other": "Bahrainin dinaaria",
        symbol: "BHD"
      },
      BIF: {
        displayName: "Burundin frangi",
        "displayName-count-one": "Burundin frangi",
        "displayName-count-other": "Burundin frangia",
        symbol: "BIF"
      },
      BMD: {
        displayName: "Bermudan dollari",
        "displayName-count-one": "Bermudan dollari",
        "displayName-count-other": "Bermudan dollaria",
        symbol: "BMD",
        "symbol-alt-narrow": "BMD"
      },
      BND: {
        displayName: "Brunein dollari",
        "displayName-count-one": "Brunein dollari",
        "displayName-count-other": "Brunein dollaria",
        symbol: "BND",
        "symbol-alt-narrow": "BND"
      },
      BOB: {
        displayName: "Bolivian boliviano",
        "displayName-count-one": "Bolivian boliviano",
        "displayName-count-other": "Bolivian bolivianoa",
        symbol: "BOB",
        "symbol-alt-narrow": "BOB"
      },
      BOL: {
        displayName: "Bolivian boliviano (1863–1963)",
        "displayName-count-one": "Bolivian boliviano (1863–1963)",
        "displayName-count-other": "Bolivian bolivianoa (1863–1963)",
        symbol: "BOL"
      },
      BOP: {
        displayName: "Bolivian peso",
        "displayName-count-one": "Bolivian peso",
        "displayName-count-other": "Bolivian pesoa",
        symbol: "BOP"
      },
      BOV: {
        displayName: "Bolivian mvdol",
        "displayName-count-one": "Bolivian mvdol",
        "displayName-count-other": "Bolivian mvdol’ia",
        symbol: "BOV"
      },
      BRB: {
        displayName: "Brasilian uusi cruzeiro (1967–1986)",
        "displayName-count-one": "Brasilian uusi cruzeiro (1967–1986)",
        "displayName-count-other": "Brasilian uutta cruzeiroa (1967–1986)",
        symbol: "BRB"
      },
      BRC: {
        displayName: "Brasilian cruzado (1986–1989)",
        "displayName-count-one": "Brasilian cruzado (1986–1989)",
        "displayName-count-other": "Brasilian cruzadoa (1986–1989)",
        symbol: "BRC"
      },
      BRE: {
        displayName: "Brasilian cruzeiro (1990–1993)",
        "displayName-count-one": "Brasilian cruzeiro (1990–1993)",
        "displayName-count-other": "Brasilian cruzeiroa (1990–1993)",
        symbol: "BRE"
      },
      BRL: {
        displayName: "Brasilian real",
        "displayName-count-one": "Brasilian real",
        "displayName-count-other": "Brasilian realia",
        symbol: "BRL",
        "symbol-alt-narrow": "BRL"
      },
      BRN: {
        displayName: "Brasilian uusi cruzado (1989–1990)",
        "displayName-count-one": "Brasilian uusi cruzado (1989–1990)",
        "displayName-count-other": "Brasilian uutta cruzadoa (1989–1990)",
        symbol: "BRN"
      },
      BRR: {
        displayName: "Brasilian cruzeiro (1993–1994)",
        "displayName-count-one": "Brasilian cruzeiro (1993–1994)",
        "displayName-count-other": "Brasilian cruzeiroa (1993–1994)",
        symbol: "BRR"
      },
      BRZ: {
        displayName: "Brasilian cruzeiro (1942–1967)",
        "displayName-count-one": "Brasilian cruzeiro (1942–1967)",
        "displayName-count-other": "Brasilian cruzeiroa (1942–1967)",
        symbol: "BRZ"
      },
      BSD: {
        displayName: "Bahaman dollari",
        "displayName-count-one": "Bahaman dollari",
        "displayName-count-other": "Bahaman dollaria",
        symbol: "BSD",
        "symbol-alt-narrow": "BSD"
      },
      BTN: {
        displayName: "Bhutanin ngultrum",
        "displayName-count-one": "Bhutanin ngultrum",
        "displayName-count-other": "Bhutanin ngultrumia",
        symbol: "BTN"
      },
      BUK: {
        displayName: "Burman kyat",
        "displayName-count-one": "Burman kyat",
        "displayName-count-other": "Burman kyatia",
        symbol: "BUK"
      },
      BWP: {
        displayName: "Botswanan pula",
        "displayName-count-one": "Botswanan pula",
        "displayName-count-other": "Botswanan pulaa",
        symbol: "BWP",
        "symbol-alt-narrow": "BWP"
      },
      BYB: {
        displayName: "Valko-Venäjän uusi rupla (1994–1999)",
        "displayName-count-one": "Valko-Venäjän uusi rupla (1994–1999)",
        "displayName-count-other": "Valko-Venäjän uutta ruplaa (1994–1999)",
        symbol: "BYB"
      },
      BYN: {
        displayName: "Valko-Venäjän rupla",
        "displayName-count-one": "Valko-Venäjän rupla",
        "displayName-count-other": "Valko-Venäjän ruplaa",
        symbol: "BYN",
        "symbol-alt-narrow": "BYN"
      },
      BYR: {
        displayName: "Valko-Venäjän rupla (2000–2016)",
        "displayName-count-one": "Valko-Venäjän rupla (2000–2016)",
        "displayName-count-other": "Valko-Venäjän ruplaa (2000–2016)",
        symbol: "BYR"
      },
      BZD: {
        displayName: "Belizen dollari",
        "displayName-count-one": "Belizen dollari",
        "displayName-count-other": "Belizen dollaria",
        symbol: "BZD",
        "symbol-alt-narrow": "BZD"
      },
      CAD: {
        displayName: "Kanadan dollari",
        "displayName-count-one": "Kanadan dollari",
        "displayName-count-other": "Kanadan dollaria",
        symbol: "CAD",
        "symbol-alt-narrow": "CAD"
      },
      CDF: {
        displayName: "Kongon frangi",
        "displayName-count-one": "Kongon frangi",
        "displayName-count-other": "Kongon frangia",
        symbol: "CDF"
      },
      CHE: {
        displayName: "Sveitsin WIR-euro",
        "displayName-count-one": "Sveitsin WIR-euro",
        "displayName-count-other": "Sveitsin WIR-euroa",
        symbol: "CHE"
      },
      CHF: {
        displayName: "Sveitsin frangi",
        "displayName-count-one": "Sveitsin frangi",
        "displayName-count-other": "Sveitsin frangia",
        symbol: "CHF"
      },
      CHW: {
        displayName: "Sveitsin WIR-frangi",
        "displayName-count-one": "Sveitsin WIR-frangi",
        "displayName-count-other": "Sveitsin WIR-frangia",
        symbol: "CHW"
      },
      CLE: {
        displayName: "Chilen escudo",
        "displayName-count-one": "Chilen escudo",
        "displayName-count-other": "Chilen escudoa",
        symbol: "CLE"
      },
      CLF: {
        displayName: "Chilen unidades de fomento",
        "displayName-count-one": "Chilen unidades de fomento",
        "displayName-count-other": "Chilen unidades de fomentoa",
        symbol: "CLF"
      },
      CLP: {
        displayName: "Chilen peso",
        "displayName-count-one": "Chilen peso",
        "displayName-count-other": "Chilen pesoa",
        symbol: "CLP",
        "symbol-alt-narrow": "CLP"
      },
      CNH: {
        displayName: "Kiinan juan (offshore)",
        "displayName-count-one": "Kiinan juan (offshore)",
        "displayName-count-other": "Kiinan juania (offshore)",
        symbol: "CNH"
      },
      CNX: {
        displayName: "Kiinan kansanpankin dollari",
        "displayName-count-one": "Kiinan kansanpankin dollari",
        "displayName-count-other": "Kiinan kansanpankin dollaria",
        symbol: "CNX"
      },
      CNY: {
        displayName: "Kiinan juan",
        "displayName-count-one": "Kiinan juan",
        "displayName-count-other": "Kiinan juania",
        symbol: "CNY",
        "symbol-alt-narrow": "CNY"
      },
      COP: {
        displayName: "Kolumbian peso",
        "displayName-count-one": "Kolumbian peso",
        "displayName-count-other": "Kolumbian pesoa",
        symbol: "COP",
        "symbol-alt-narrow": "COP"
      },
      COU: {
        displayName: "Kolumbian unidad de valor real",
        "displayName-count-one": "Kolumbian unidad de valor real",
        "displayName-count-other": "Kolumbian unidad de valor realia",
        symbol: "COU"
      },
      CRC: {
        displayName: "Costa Rican colón",
        "displayName-count-one": "Costa Rican colón",
        "displayName-count-other": "Costa Rican colónia",
        symbol: "CRC",
        "symbol-alt-narrow": "CRC"
      },
      CSD: {
        displayName: "Serbian dinaari (2002–2006)",
        "displayName-count-one": "Serbian dinaari (2002–2006)",
        "displayName-count-other": "Serbian dinaaria (2002–2006)",
        symbol: "CSD"
      },
      CSK: {
        displayName: "Tšekkoslovakian kova koruna",
        "displayName-count-one": "Tšekkoslovakian kova koruna",
        "displayName-count-other": "Tšekkoslovakian kovaa korunaa",
        symbol: "CSK"
      },
      CUC: {
        displayName: "Kuuban vaihdettava peso",
        "displayName-count-one": "Kuuban vaihdettava peso",
        "displayName-count-other": "Kuuban vaihdettavaa pesoa",
        symbol: "CUC",
        "symbol-alt-narrow": "CUC"
      },
      CUP: {
        displayName: "Kuuban peso",
        "displayName-count-one": "Kuuban peso",
        "displayName-count-other": "Kuuban pesoa",
        symbol: "CUP",
        "symbol-alt-narrow": "CUP"
      },
      CVE: {
        displayName: "Kap Verden escudo",
        "displayName-count-one": "Kap Verden escudo",
        "displayName-count-other": "Kap Verden escudoa",
        symbol: "CVE"
      },
      CYP: {
        displayName: "Kyproksen punta",
        "displayName-count-one": "Kyproksen punta",
        "displayName-count-other": "Kyproksen puntaa",
        symbol: "CYP"
      },
      CZK: {
        displayName: "Tšekin koruna",
        "displayName-count-one": "Tšekin koruna",
        "displayName-count-other": "Tšekin korunaa",
        symbol: "CZK",
        "symbol-alt-narrow": "CZK"
      },
      DDM: {
        displayName: "Itä-Saksan markka",
        "displayName-count-one": "Itä-Saksan markka",
        "displayName-count-other": "Itä-Saksan markkaa",
        symbol: "DDM"
      },
      DEM: {
        displayName: "Saksan markka",
        "displayName-count-one": "Saksan markka",
        "displayName-count-other": "Saksan markkaa",
        symbol: "DEM"
      },
      DJF: {
        displayName: "Djiboutin frangi",
        "displayName-count-one": "Djiboutin frangi",
        "displayName-count-other": "Djiboutin frangia",
        symbol: "DJF"
      },
      DKK: {
        displayName: "Tanskan kruunu",
        "displayName-count-one": "Tanskan kruunu",
        "displayName-count-other": "Tanskan kruunua",
        symbol: "DKK",
        "symbol-alt-narrow": "DKK"
      },
      DOP: {
        displayName: "Dominikaanisen tasavallan peso",
        "displayName-count-one": "Dominikaanisen tasavallan peso",
        "displayName-count-other": "Dominikaanisen tasavallan pesoa",
        symbol: "DOP",
        "symbol-alt-narrow": "DOP"
      },
      DZD: {
        displayName: "Algerian dinaari",
        "displayName-count-one": "Algerian dinaari",
        "displayName-count-other": "Algerian dinaaria",
        symbol: "DZD"
      },
      ECS: {
        displayName: "Ecuadorin sucre",
        "displayName-count-one": "Ecuadorin sucre",
        "displayName-count-other": "Ecuadorin sucrea",
        symbol: "ECS"
      },
      ECV: {
        displayName: "Ecuadorin UVC",
        "displayName-count-one": "Ecuadorin UVC",
        "displayName-count-other": "Ecuadorin UVC’ta",
        symbol: "ECV"
      },
      EEK: {
        displayName: "Viron kruunu",
        "displayName-count-one": "Viron kruunu",
        "displayName-count-other": "Viron kruunua",
        symbol: "EEK"
      },
      EGP: {
        displayName: "Egyptin punta",
        "displayName-count-one": "Egyptin punta",
        "displayName-count-other": "Egyptin puntaa",
        symbol: "EGP",
        "symbol-alt-narrow": "EGP"
      },
      ERN: {
        displayName: "Eritrean nakfa",
        "displayName-count-one": "Eritrean nakfa",
        "displayName-count-other": "Eritrean nakfaa",
        symbol: "ERN"
      },
      ESA: {
        displayName: "Espanjan peseta (A-tili)",
        "displayName-count-one": "Espanjan peseta (A-tili)",
        "displayName-count-other": "Espanjan pesetaa (A-tili)",
        symbol: "ESA"
      },
      ESB: {
        displayName: "Espanjan peseta (vaihdettava tili)",
        "displayName-count-one": "Espanjan peseta (vaihdettava tili)",
        "displayName-count-other": "Espanjan pesetaa (vaihdettava tili)",
        symbol: "ESB"
      },
      ESP: {
        displayName: "Espanjan peseta",
        "displayName-count-one": "Espanjan peseta",
        "displayName-count-other": "Espanjan pesetaa",
        symbol: "ESP",
        "symbol-alt-narrow": "ESP"
      },
      ETB: {
        displayName: "Etiopian birr",
        "displayName-count-one": "Etiopian birr",
        "displayName-count-other": "Etiopian birriä",
        symbol: "ETB"
      },
      EUR: {
        displayName: "euro",
        "displayName-count-one": "euro",
        "displayName-count-other": "euroa",
        symbol: "€",
        "symbol-alt-narrow": "€"
      },
      FIM: {
        displayName: "Suomen markka",
        "displayName-count-one": "Suomen markka",
        "displayName-count-other": "Suomen markkaa",
        symbol: "mk"
      },
      FJD: {
        displayName: "Fidžin dollari",
        "displayName-count-one": "Fidžin dollari",
        "displayName-count-other": "Fidžin dollaria",
        symbol: "FJD",
        "symbol-alt-narrow": "FJD"
      },
      FKP: {
        displayName: "Falklandinsaarten punta",
        "displayName-count-one": "Falklandinsaarten punta",
        "displayName-count-other": "Falklandinsaarten puntaa",
        symbol: "FKP",
        "symbol-alt-narrow": "FKP"
      },
      FRF: {
        displayName: "Ranskan frangi",
        "displayName-count-one": "Ranskan frangi",
        "displayName-count-other": "Ranskan frangia",
        symbol: "FRF"
      },
      GBP: {
        displayName: "Englannin punta",
        "displayName-count-one": "Englannin punta",
        "displayName-count-other": "Englannin puntaa",
        symbol: "£",
        "symbol-alt-narrow": "£"
      },
      GEK: {
        displayName: "Georgian kuponkilari",
        "displayName-count-one": "Georgian kuponkilari",
        "displayName-count-other": "Georgian kuponkilaria",
        symbol: "GEK"
      },
      GEL: {
        displayName: "Georgian lari",
        "displayName-count-one": "Georgian lari",
        "displayName-count-other": "Georgian laria",
        symbol: "GEL",
        "symbol-alt-narrow": "GEL"
      },
      GHC: {
        displayName: "Ghanan cedi (1979–2007)",
        "displayName-count-one": "Ghanan cedi (1979–2007)",
        "displayName-count-other": "Ghanan cediä (1979–2007)",
        symbol: "GHC"
      },
      GHS: {
        displayName: "Ghanan cedi",
        "displayName-count-one": "Ghanan cedi",
        "displayName-count-other": "Ghanan cediä",
        symbol: "GHS",
        "symbol-alt-narrow": "GH₵"
      },
      GIP: {
        displayName: "Gibraltarin punta",
        "displayName-count-one": "Gibraltarin punta",
        "displayName-count-other": "Gibraltarin puntaa",
        symbol: "GIP",
        "symbol-alt-narrow": "GIP"
      },
      GMD: {
        displayName: "Gambian dalasi",
        "displayName-count-one": "Gambian dalasi",
        "displayName-count-other": "Gambian dalasia",
        symbol: "GMD"
      },
      GNF: {
        displayName: "Guinean frangi",
        "displayName-count-one": "Guinean frangi",
        "displayName-count-other": "Guinean frangia",
        symbol: "GNF",
        "symbol-alt-narrow": "GNF"
      },
      GNS: {
        displayName: "Guinean syli",
        "displayName-count-one": "Guinean syli",
        "displayName-count-other": "Guinean syliä",
        symbol: "GNS"
      },
      GQE: {
        displayName: "Päiväntasaajan Guinean ekwele",
        "displayName-count-one": "Päiväntasaajan Guinean ekwele",
        "displayName-count-other": "Päiväntasaajan Guinean ekweleä",
        symbol: "GQE"
      },
      GRD: {
        displayName: "Kreikan drakma",
        "displayName-count-one": "Kreikan drakma",
        "displayName-count-other": "Kreikan drakmaa",
        symbol: "GRD"
      },
      GTQ: {
        displayName: "Guatemalan quetzal",
        "displayName-count-one": "Guatemalan quetzal",
        "displayName-count-other": "Guatemalan quetzalia",
        symbol: "GTQ",
        "symbol-alt-narrow": "GTQ"
      },
      GWE: {
        displayName: "Portugalin Guinean escudo",
        "displayName-count-one": "Portugalin Guinean escudo",
        "displayName-count-other": "Portugalin Guinean escudoa",
        symbol: "GWE"
      },
      GWP: {
        displayName: "Guinea-Bissaun peso",
        "displayName-count-one": "Guinea-Bissaun peso",
        "displayName-count-other": "Guinea-Bissaun pesoa",
        symbol: "GWP"
      },
      GYD: {
        displayName: "Guyanan dollari",
        "displayName-count-one": "Guyanan dollari",
        "displayName-count-other": "Guyanan dollaria",
        symbol: "GYD",
        "symbol-alt-narrow": "GYD"
      },
      HKD: {
        displayName: "Hongkongin dollari",
        "displayName-count-one": "Hongkongin dollari",
        "displayName-count-other": "Hongkongin dollaria",
        symbol: "HKD",
        "symbol-alt-narrow": "HKD"
      },
      HNL: {
        displayName: "Hondurasin lempira",
        "displayName-count-one": "Hondurasin lempira",
        "displayName-count-other": "Hondurasin lempiraa",
        symbol: "HNL",
        "symbol-alt-narrow": "HNL"
      },
      HRD: {
        displayName: "Kroatian dinaari",
        "displayName-count-one": "Kroatian dinaari",
        "displayName-count-other": "Kroatian dinaaria",
        symbol: "HRD"
      },
      HRK: {
        displayName: "Kroatian kuna",
        "displayName-count-one": "Kroatian kuna",
        "displayName-count-other": "Kroatian kunaa",
        symbol: "HRK",
        "symbol-alt-narrow": "HRK"
      },
      HTG: {
        displayName: "Haitin gourde",
        "displayName-count-one": "Haitin gourde",
        "displayName-count-other": "Haitin gourdea",
        symbol: "HTG"
      },
      HUF: {
        displayName: "Unkarin forintti",
        "displayName-count-one": "Unkarin forintti",
        "displayName-count-other": "Unkarin forinttia",
        symbol: "HUF",
        "symbol-alt-narrow": "HUF"
      },
      IDR: {
        displayName: "Indonesian rupia",
        "displayName-count-one": "Indonesian rupia",
        "displayName-count-other": "Indonesian rupiaa",
        symbol: "IDR",
        "symbol-alt-narrow": "IDR"
      },
      IEP: {
        displayName: "Irlannin punta",
        "displayName-count-one": "Irlannin punta",
        "displayName-count-other": "Irlannin puntaa",
        symbol: "IEP"
      },
      ILP: {
        displayName: "Israelin punta",
        "displayName-count-one": "Israelin punta",
        "displayName-count-other": "Israelin puntaa",
        symbol: "ILP"
      },
      ILR: {
        displayName: "Israelin sekeli (1980–1985)",
        "displayName-count-one": "Israelin sekeli (1980–1985)",
        "displayName-count-other": "Israelin sekeliä (1980–1985)",
        symbol: "ILR"
      },
      ILS: {
        displayName: "Israelin uusi sekeli",
        "displayName-count-one": "Israelin uusi sekeli",
        "displayName-count-other": "Israelin uutta sekeliä",
        symbol: "ILS",
        "symbol-alt-narrow": "ILS"
      },
      INR: {
        displayName: "Intian rupia",
        "displayName-count-one": "Intian rupia",
        "displayName-count-other": "Intian rupiaa",
        symbol: "INR",
        "symbol-alt-narrow": "INR"
      },
      IQD: {
        displayName: "Irakin dinaari",
        "displayName-count-one": "Irakin dinaari",
        "displayName-count-other": "Irakin dinaaria",
        symbol: "IQD"
      },
      IRR: {
        displayName: "Iranin rial",
        "displayName-count-one": "Iranin rial",
        "displayName-count-other": "Iranin rialia",
        symbol: "IRR"
      },
      ISJ: {
        displayName: "Islannin kruunu (1918–1981)",
        "displayName-count-one": "Islannin kruunu (1918–1981)",
        "displayName-count-other": "Islannin kruunua (1918–1981)",
        symbol: "ISJ"
      },
      ISK: {
        displayName: "Islannin kruunu",
        "displayName-count-one": "Islannin kruunu",
        "displayName-count-other": "Islannin kruunua",
        symbol: "ISK",
        "symbol-alt-narrow": "ISK"
      },
      ITL: {
        displayName: "Italian liira",
        "displayName-count-one": "Italian liira",
        "displayName-count-other": "Italian liiraa",
        symbol: "ITL"
      },
      JMD: {
        displayName: "Jamaikan dollari",
        "displayName-count-one": "Jamaikan dollari",
        "displayName-count-other": "Jamaikan dollaria",
        symbol: "JMD",
        "symbol-alt-narrow": "JMD"
      },
      JOD: {
        displayName: "Jordanian dinaari",
        "displayName-count-one": "Jordanian dinaari",
        "displayName-count-other": "Jordanian dinaaria",
        symbol: "JOD"
      },
      JPY: {
        displayName: "Japanin jeni",
        "displayName-count-one": "Japanin jeni",
        "displayName-count-other": "Japanin jeniä",
        symbol: "¥",
        "symbol-alt-narrow": "¥"
      },
      KES: {
        displayName: "Kenian šillinki",
        "displayName-count-one": "Kenian šillinki",
        "displayName-count-other": "Kenian šillinkiä",
        symbol: "KES"
      },
      KGS: {
        displayName: "Kirgisian som",
        "displayName-count-one": "Kirgisian som",
        "displayName-count-other": "Kirgisian somia",
        symbol: "KGS"
      },
      KHR: {
        displayName: "Kambodžan riel",
        "displayName-count-one": "Kambodžan riel",
        "displayName-count-other": "Kambodžan rieliä",
        symbol: "KHR",
        "symbol-alt-narrow": "KHR"
      },
      KMF: {
        displayName: "Komorien frangi",
        "displayName-count-one": "Komorien frangi",
        "displayName-count-other": "Komorien frangia",
        symbol: "KMF",
        "symbol-alt-narrow": "KMF"
      },
      KPW: {
        displayName: "Pohjois-Korean won",
        "displayName-count-one": "Pohjois-Korean won",
        "displayName-count-other": "Pohjois-Korean wonia",
        symbol: "KPW",
        "symbol-alt-narrow": "KPW"
      },
      KRH: {
        displayName: "Etelä-Korean hwan (1953–1962)",
        "displayName-count-one": "Etelä-Korean hwan (1953–1962)",
        "displayName-count-other": "Etelä-Korean hwania (1953–1962)",
        symbol: "KRH"
      },
      KRO: {
        displayName: "Etelä-Korean won (1945–1953)",
        "displayName-count-one": "Etelä-Korean won (1945–1953)",
        "displayName-count-other": "Etelä-Korean wonia (1945–1953)",
        symbol: "KRO"
      },
      KRW: {
        displayName: "Etelä-Korean won",
        "displayName-count-one": "Etelä-Korean won",
        "displayName-count-other": "Etelä-Korean wonia",
        symbol: "KRW",
        "symbol-alt-narrow": "KRW"
      },
      KWD: {
        displayName: "Kuwaitin dinaari",
        "displayName-count-one": "Kuwaitin dinaari",
        "displayName-count-other": "Kuwaitin dinaaria",
        symbol: "KWD"
      },
      KYD: {
        displayName: "Caymansaarten dollari",
        "displayName-count-one": "Caymansaarten dollari",
        "displayName-count-other": "Caymansaarten dollaria",
        symbol: "KYD",
        "symbol-alt-narrow": "KYD"
      },
      KZT: {
        displayName: "Kazakstanin tenge",
        "displayName-count-one": "Kazakstanin tenge",
        "displayName-count-other": "Kazakstanin tengeä",
        symbol: "KZT",
        "symbol-alt-narrow": "KZT"
      },
      LAK: {
        displayName: "Laosin kip",
        "displayName-count-one": "Laosin kip",
        "displayName-count-other": "Laosin kipiä",
        symbol: "LAK",
        "symbol-alt-narrow": "LAK"
      },
      LBP: {
        displayName: "Libanonin punta",
        "displayName-count-one": "Libanonin punta",
        "displayName-count-other": "Libanonin puntaa",
        symbol: "LBP",
        "symbol-alt-narrow": "LBP"
      },
      LKR: {
        displayName: "Sri Lankan rupia",
        "displayName-count-one": "Sri Lankan rupia",
        "displayName-count-other": "Sri Lankan rupiaa",
        symbol: "LKR",
        "symbol-alt-narrow": "LKR"
      },
      LRD: {
        displayName: "Liberian dollari",
        "displayName-count-one": "Liberian dollari",
        "displayName-count-other": "Liberian dollaria",
        symbol: "LRD",
        "symbol-alt-narrow": "LRD"
      },
      LSL: {
        displayName: "Lesothon loti",
        "displayName-count-one": "Lesothon loti",
        "displayName-count-other": "Lesothon lotia",
        symbol: "LSL"
      },
      LTL: {
        displayName: "Liettuan liti",
        "displayName-count-one": "Liettuan liti",
        "displayName-count-other": "Liettuan litiä",
        symbol: "LTL",
        "symbol-alt-narrow": "LTL"
      },
      LTT: {
        displayName: "Liettuan talonas",
        "displayName-count-one": "Liettuan talonas",
        "displayName-count-other": "Liettuan talonasia",
        symbol: "LTT"
      },
      LUC: {
        displayName: "Luxemburgin vaihdettava frangi",
        "displayName-count-one": "Luxemburgin vaihdettava frangi",
        "displayName-count-other": "Luxemburgin vaihdettavaa frangia",
        symbol: "LUC"
      },
      LUF: {
        displayName: "Luxemburgin frangi",
        "displayName-count-one": "Luxemburgin frangi",
        "displayName-count-other": "Luxemburgin frangia",
        symbol: "LUF"
      },
      LUL: {
        displayName: "Luxemburgin rahoitusfrangi",
        "displayName-count-one": "Luxemburgin rahoitusfrangi",
        "displayName-count-other": "Luxemburgin rahoitusfrangia",
        symbol: "LUL"
      },
      LVL: {
        displayName: "Latvian lati",
        "displayName-count-one": "Latvian lati",
        "displayName-count-other": "Latvian latia",
        symbol: "LVL",
        "symbol-alt-narrow": "LVL"
      },
      LVR: {
        displayName: "Latvian rupla",
        "displayName-count-one": "Latvian rupla",
        "displayName-count-other": "Latvian ruplaa",
        symbol: "LVR"
      },
      LYD: {
        displayName: "Libyan dinaari",
        "displayName-count-one": "Libyan dinaari",
        "displayName-count-other": "Libyan dinaaria",
        symbol: "LYD"
      },
      MAD: {
        displayName: "Marokon dirhami",
        "displayName-count-one": "Marokon dirhami",
        "displayName-count-other": "Marokon dirhamia",
        symbol: "MAD"
      },
      MAF: {
        displayName: "Marokon frangi",
        "displayName-count-one": "Marokon frangi",
        "displayName-count-other": "Marokon frangia",
        symbol: "MAF"
      },
      MCF: {
        displayName: "Monacon frangi",
        "displayName-count-one": "Monacon frangi",
        "displayName-count-other": "Monacon frangia",
        symbol: "MCF"
      },
      MDC: {
        displayName: "Moldovan kuponkileu",
        "displayName-count-one": "Moldovan kuponkileu",
        "displayName-count-other": "Moldovan kuponkileuta",
        symbol: "MDC"
      },
      MDL: {
        displayName: "Moldovan leu",
        "displayName-count-one": "Moldovan leu",
        "displayName-count-other": "Moldovan leuta",
        symbol: "MDL"
      },
      MGA: {
        displayName: "Madagaskarin ariary",
        "displayName-count-one": "Madagaskarin ariary",
        "displayName-count-other": "Madagaskarin ariarya",
        symbol: "MGA",
        "symbol-alt-narrow": "MGA"
      },
      MGF: {
        displayName: "Madagaskarin frangi",
        "displayName-count-one": "Madagaskarin frangi",
        "displayName-count-other": "Madagaskarin frangia",
        symbol: "MGF"
      },
      MKD: {
        displayName: "Makedonian denaari",
        "displayName-count-one": "Makedonian denaari",
        "displayName-count-other": "Makedonian denaaria",
        symbol: "MKD"
      },
      MKN: {
        displayName: "Makedonian dinaari (1992–1993)",
        "displayName-count-one": "Makedonian dinaari (1992–1993)",
        "displayName-count-other": "Makedonian dinaaria (1992–1993)",
        symbol: "MKN"
      },
      MLF: {
        displayName: "Malin frangi",
        "displayName-count-one": "Malin frangi",
        "displayName-count-other": "Malin frangia",
        symbol: "MLF"
      },
      MMK: {
        displayName: "Myanmarin kyat",
        "displayName-count-one": "Myanmarin kyat",
        "displayName-count-other": "Myanmarin kyatia",
        symbol: "MMK",
        "symbol-alt-narrow": "MMK"
      },
      MNT: {
        displayName: "Mongolian tugrik",
        "displayName-count-one": "Mongolian tugrik",
        "displayName-count-other": "Mongolian tugrikia",
        symbol: "MNT",
        "symbol-alt-narrow": "MNT"
      },
      MOP: {
        displayName: "Macaon pataca",
        "displayName-count-one": "Macaon pataca",
        "displayName-count-other": "Macaon patacaa",
        symbol: "MOP"
      },
      MRO: {
        displayName: "Mauritanian ouguiya (1973–2017)",
        "displayName-count-one": "Mauritanian ouguiya (1973–2017)",
        "displayName-count-other": "Mauritanian ouguiyaa (1973–2017)",
        symbol: "MRO"
      },
      MRU: {
        displayName: "Mauritanian ouguiya",
        "displayName-count-one": "Mauritanian ouguiya",
        "displayName-count-other": "Mauritanian ouguiyaa",
        symbol: "MRU"
      },
      MTL: {
        displayName: "Maltan liira",
        "displayName-count-one": "Maltan liira",
        "displayName-count-other": "Maltan liiraa",
        symbol: "MTL"
      },
      MTP: {
        displayName: "Maltan punta",
        "displayName-count-one": "Maltan punta",
        "displayName-count-other": "Maltan puntaa",
        symbol: "MTP"
      },
      MUR: {
        displayName: "Mauritiuksen rupia",
        "displayName-count-one": "Mauritiuksen rupia",
        "displayName-count-other": "Mauritiuksen rupiaa",
        symbol: "MUR",
        "symbol-alt-narrow": "MUR"
      },
      MVP: {
        displayName: "Malediivien rupia (1947–1981)",
        "displayName-count-one": "Malediivien rupia (1947–1981)",
        "displayName-count-other": "Malediivien rupiaa (1947–1981)",
        symbol: "MVP"
      },
      MVR: {
        displayName: "Malediivien rufiyaa",
        "displayName-count-one": "Malediivien rufiyaa",
        "displayName-count-other": "Malediivien rufiyaata",
        symbol: "MVR"
      },
      MWK: {
        displayName: "Malawin kwacha",
        "displayName-count-one": "Malawin kwacha",
        "displayName-count-other": "Malawin kwachaa",
        symbol: "MWK"
      },
      MXN: {
        displayName: "Meksikon peso",
        "displayName-count-one": "Meksikon peso",
        "displayName-count-other": "Meksikon pesoa",
        symbol: "MXN",
        "symbol-alt-narrow": "MXN"
      },
      MXP: {
        displayName: "Meksikon hopeapeso (1861–1992)",
        "displayName-count-one": "Meksikon hopeapeso (1861–1992)",
        "displayName-count-other": "Meksikon hopeapesoa (1861–1992)",
        symbol: "MXP"
      },
      MXV: {
        displayName: "Meksikon UDI",
        "displayName-count-one": "Meksikon UDI",
        "displayName-count-other": "Meksikon UDI’ta",
        symbol: "MXV"
      },
      MYR: {
        displayName: "Malesian ringgit",
        "displayName-count-one": "Malesian ringgit",
        "displayName-count-other": "Malesian ringgitiä",
        symbol: "MYR",
        "symbol-alt-narrow": "MYR"
      },
      MZE: {
        displayName: "Mosambikin escudo",
        "displayName-count-one": "Mosambikin escudo",
        "displayName-count-other": "Mosambikin escudoa",
        symbol: "MZE"
      },
      MZM: {
        displayName: "Mosambikin metical (1980–2006)",
        "displayName-count-one": "Mosambikin metical (1980–2006)",
        "displayName-count-other": "Mosambikin meticalia (1980–2006)",
        symbol: "MZM"
      },
      MZN: {
        displayName: "Mosambikin metical",
        "displayName-count-one": "Mosambikin metical",
        "displayName-count-other": "Mosambikin meticalia",
        symbol: "MZN"
      },
      NAD: {
        displayName: "Namibian dollari",
        "displayName-count-one": "Namibian dollari",
        "displayName-count-other": "Namibian dollaria",
        symbol: "NAD",
        "symbol-alt-narrow": "NAD"
      },
      NGN: {
        displayName: "Nigerian naira",
        "displayName-count-one": "Nigerian naira",
        "displayName-count-other": "Nigerian nairaa",
        symbol: "NGN",
        "symbol-alt-narrow": "NGN"
      },
      NIC: {
        displayName: "Nicaraguan córdoba (1988–1991)",
        "displayName-count-one": "Nicaraguan córdoba (1988–1991)",
        "displayName-count-other": "Nicaraguan córdobaa (1988–1991)",
        symbol: "NIC"
      },
      NIO: {
        displayName: "Nicaraguan córdoba",
        "displayName-count-one": "Nicaraguan córdoba",
        "displayName-count-other": "Nicaraguan córdobaa",
        symbol: "NIO",
        "symbol-alt-narrow": "NIO"
      },
      NLG: {
        displayName: "Alankomaiden guldeni",
        "displayName-count-one": "Alankomaiden guldeni",
        "displayName-count-other": "Alankomaiden guldenia",
        symbol: "NLG"
      },
      NOK: {
        displayName: "Norjan kruunu",
        "displayName-count-one": "Norjan kruunu",
        "displayName-count-other": "Norjan kruunua",
        symbol: "NOK",
        "symbol-alt-narrow": "NOK"
      },
      NPR: {
        displayName: "Nepalin rupia",
        "displayName-count-one": "Nepalin rupia",
        "displayName-count-other": "Nepalin rupiaa",
        symbol: "NPR",
        "symbol-alt-narrow": "NPR"
      },
      NZD: {
        displayName: "Uuden-Seelannin dollari",
        "displayName-count-one": "Uuden-Seelannin dollari",
        "displayName-count-other": "Uuden-Seelannin dollaria",
        symbol: "NZD",
        "symbol-alt-narrow": "NZD"
      },
      OMR: {
        displayName: "Omanin rial",
        "displayName-count-one": "Omanin rial",
        "displayName-count-other": "Omanin rialia",
        symbol: "OMR"
      },
      PAB: {
        displayName: "Panaman balboa",
        "displayName-count-one": "Panaman balboa",
        "displayName-count-other": "Panaman balboaa",
        symbol: "PAB"
      },
      PEI: {
        displayName: "Perun inti",
        "displayName-count-one": "Perun inti",
        "displayName-count-other": "Perun intiä",
        symbol: "PEI"
      },
      PEN: {
        displayName: "Perun sol",
        "displayName-count-one": "Perun sol",
        "displayName-count-other": "Perun solia",
        symbol: "PEN"
      },
      PES: {
        displayName: "Perun sol (1863–1965)",
        "displayName-count-one": "Perun sol (1863–1965)",
        "displayName-count-other": "Perun solia (1863–1965)",
        symbol: "PES"
      },
      PGK: {
        displayName: "Papua-Uuden-Guinean kina",
        "displayName-count-one": "Papua-Uuden-Guinean kina",
        "displayName-count-other": "Papua-Uuden-Guinean kinaa",
        symbol: "PGK"
      },
      PHP: {
        displayName: "Filippiinien peso",
        "displayName-count-one": "Filippiinien peso",
        "displayName-count-other": "Filippiinien pesoa",
        symbol: "PHP",
        "symbol-alt-narrow": "PHP"
      },
      PKR: {
        displayName: "Pakistanin rupia",
        "displayName-count-one": "Pakistanin rupia",
        "displayName-count-other": "Pakistanin rupiaa",
        symbol: "PKR",
        "symbol-alt-narrow": "PKR"
      },
      PLN: {
        displayName: "Puolan złoty",
        "displayName-count-one": "Puolan złoty",
        "displayName-count-other": "Puolan złotya",
        symbol: "PLN",
        "symbol-alt-narrow": "PLN"
      },
      PLZ: {
        displayName: "Puolan złoty (1950–1995)",
        "displayName-count-one": "Puolan złoty (1950–1995)",
        "displayName-count-other": "Puolan złotya (1950–1995)",
        symbol: "PLZ"
      },
      PTE: {
        displayName: "Portugalin escudo",
        "displayName-count-one": "Portugalin escudo",
        "displayName-count-other": "Portugalin escudoa",
        symbol: "PTE"
      },
      PYG: {
        displayName: "Paraguayn guarani",
        "displayName-count-one": "Paraguayn guarani",
        "displayName-count-other": "Paraguayn guarania",
        symbol: "PYG",
        "symbol-alt-narrow": "PYG"
      },
      QAR: {
        displayName: "Qatarin rial",
        "displayName-count-one": "Qatarin rial",
        "displayName-count-other": "Qatarin rialia",
        symbol: "QAR"
      },
      RHD: {
        displayName: "Rhodesian dollari",
        "displayName-count-one": "Rhodesian dollari",
        "displayName-count-other": "Rhodesian dollaria",
        symbol: "RHD"
      },
      ROL: {
        displayName: "Romanian leu (1952–2006)",
        "displayName-count-one": "Romanian leu (1952–2006)",
        "displayName-count-other": "Romanian leuta (1952–2006)",
        symbol: "ROL"
      },
      RON: {
        displayName: "Romanian leu",
        "displayName-count-one": "Romanian leu",
        "displayName-count-other": "Romanian leuta",
        symbol: "RON",
        "symbol-alt-narrow": "RON"
      },
      RSD: {
        displayName: "Serbian dinaari",
        "displayName-count-one": "Serbian dinaari",
        "displayName-count-other": "Serbian dinaaria",
        symbol: "RSD"
      },
      RUB: {
        displayName: "Venäjän rupla",
        "displayName-count-one": "Venäjän rupla",
        "displayName-count-other": "Venäjän ruplaa",
        symbol: "RUB",
        "symbol-alt-narrow": "₽"
      },
      RUR: {
        displayName: "Venäjän rupla (1991–1998)",
        "displayName-count-one": "Venäjän rupla (1991–1998)",
        "displayName-count-other": "Venäjän ruplaa (1991–1998)",
        symbol: "RUR"
      },
      RWF: {
        displayName: "Ruandan frangi",
        "displayName-count-one": "Ruandan frangi",
        "displayName-count-other": "Ruandan frangia",
        symbol: "RWF",
        "symbol-alt-narrow": "RWF"
      },
      SAR: {
        displayName: "Saudi-Arabian rial",
        "displayName-count-one": "Saudi-Arabian rial",
        "displayName-count-other": "Saudi-Arabian rialia",
        symbol: "SAR"
      },
      SBD: {
        displayName: "Salomonsaarten dollari",
        "displayName-count-one": "Salomonsaarten dollari",
        "displayName-count-other": "Salomonsaarten dollaria",
        symbol: "SBD",
        "symbol-alt-narrow": "SBD"
      },
      SCR: {
        displayName: "Seychellien rupia",
        "displayName-count-one": "Seychellien rupia",
        "displayName-count-other": "Seychellien rupiaa",
        symbol: "SCR"
      },
      SDD: {
        displayName: "Sudanin dinaari (1992–2007)",
        "displayName-count-one": "Sudanin dinaari (1992–2007)",
        "displayName-count-other": "Sudanin dinaaria (1992–2007)",
        symbol: "SDD"
      },
      SDG: {
        displayName: "Sudanin punta",
        "displayName-count-one": "Sudanin punta",
        "displayName-count-other": "Sudanin puntaa",
        symbol: "SDG"
      },
      SDP: {
        displayName: "Sudanin punta (1957–1998)",
        "displayName-count-one": "Sudanin punta (1957–1998)",
        "displayName-count-other": "Sudanin puntaa (1957–1998)",
        symbol: "SDP"
      },
      SEK: {
        displayName: "Ruotsin kruunu",
        "displayName-count-one": "Ruotsin kruunu",
        "displayName-count-other": "Ruotsin kruunua",
        symbol: "SEK",
        "symbol-alt-narrow": "SEK"
      },
      SGD: {
        displayName: "Singaporen dollari",
        "displayName-count-one": "Singaporen dollari",
        "displayName-count-other": "Singaporen dollaria",
        symbol: "SGD",
        "symbol-alt-narrow": "SGD"
      },
      SHP: {
        displayName: "Saint Helenan punta",
        "displayName-count-one": "Saint Helenan punta",
        "displayName-count-other": "Saint Helenan puntaa",
        symbol: "SHP",
        "symbol-alt-narrow": "SHP"
      },
      SIT: {
        displayName: "Slovenian tolar",
        "displayName-count-one": "Slovenian tolar",
        "displayName-count-other": "Slovenian tolaria",
        symbol: "SIT"
      },
      SKK: {
        displayName: "Slovakian koruna",
        "displayName-count-one": "Slovakian koruna",
        "displayName-count-other": "Slovakian korunaa",
        symbol: "SKK"
      },
      SLE: {
        displayName: "SLE",
        symbol: "SLE"
      },
      SLL: {
        displayName: "Sierra Leonen leone",
        "displayName-count-one": "Sierra Leonen leone",
        "displayName-count-other": "Sierra Leonen leonea",
        symbol: "SLL"
      },
      SOS: {
        displayName: "Somalian šillinki",
        "displayName-count-one": "Somalian šillinki",
        "displayName-count-other": "Somalian šillinkiä",
        symbol: "SOS"
      },
      SRD: {
        displayName: "Surinamen dollari",
        "displayName-count-one": "Surinamen dollari",
        "displayName-count-other": "Surinamen dollaria",
        symbol: "SRD",
        "symbol-alt-narrow": "SRD"
      },
      SRG: {
        displayName: "Surinamen guldeni",
        "displayName-count-one": "Surinamen guldeni",
        "displayName-count-other": "Surinamen guldeni",
        symbol: "SRG"
      },
      SSP: {
        displayName: "Etelä-Sudanin punta",
        "displayName-count-one": "Etelä-Sudanin punta",
        "displayName-count-other": "Etelä-Sudanin puntaa",
        symbol: "SSP",
        "symbol-alt-narrow": "SSP"
      },
      STD: {
        displayName: "São Tomén ja Príncipen dobra (1977–2017)",
        "displayName-count-one": "São Tomén ja Príncipen dobra (1977–2017)",
        "displayName-count-other": "São Tomén ja Príncipen dobraa (1977–2017)",
        symbol: "STD"
      },
      STN: {
        displayName: "São Tomén ja Príncipen dobra",
        "displayName-count-one": "São Tomén ja Príncipen dobra",
        "displayName-count-other": "São Tomén ja Príncipen dobraa",
        symbol: "STN",
        "symbol-alt-narrow": "STD"
      },
      SUR: {
        displayName: "Neuvostoliiton rupla",
        "displayName-count-one": "Neuvostoliiton rupla",
        "displayName-count-other": "Neuvostoliiton ruplaa",
        symbol: "SUR"
      },
      SVC: {
        displayName: "El Salvadorin colón",
        "displayName-count-one": "El Salvadorin colón",
        "displayName-count-other": "El Salvadorin colónia",
        symbol: "SVC"
      },
      SYP: {
        displayName: "Syyrian punta",
        "displayName-count-one": "Syyrian punta",
        "displayName-count-other": "Syyrian puntaa",
        symbol: "SYP",
        "symbol-alt-narrow": "SYP"
      },
      SZL: {
        displayName: "Swazimaan lilangeni",
        "displayName-count-one": "Swazimaan lilangeni",
        "displayName-count-other": "Swazimaan lilangenia",
        symbol: "SZL"
      },
      THB: {
        displayName: "Thaimaan baht",
        "displayName-count-one": "Thaimaan baht",
        "displayName-count-other": "Thaimaan bahtia",
        symbol: "THB",
        "symbol-alt-narrow": "THB"
      },
      TJR: {
        displayName: "Tadžikistanin rupla",
        "displayName-count-one": "Tadžikistanin rupla",
        "displayName-count-other": "Tadžikistanin ruplaa",
        symbol: "TJR"
      },
      TJS: {
        displayName: "Tadžikistanin somoni",
        "displayName-count-one": "Tadžikistanin somoni",
        "displayName-count-other": "Tadžikistanin somonia",
        symbol: "TJS"
      },
      TMM: {
        displayName: "Turkmenistanin manat (1993–2009)",
        "displayName-count-one": "Turkmenistanin manat (1993–2009)",
        "displayName-count-other": "Turkmenistanin manatia (1993–2009)",
        symbol: "TMM"
      },
      TMT: {
        displayName: "Turkmenistanin manat",
        "displayName-count-one": "Turkmenistanin manat",
        "displayName-count-other": "Turkmenistanin manatia",
        symbol: "TMT"
      },
      TND: {
        displayName: "Tunisian dinaari",
        "displayName-count-one": "Tunisian dinaari",
        "displayName-count-other": "Tunisian dinaaria",
        symbol: "TND"
      },
      TOP: {
        displayName: "Tongan pa’anga",
        "displayName-count-one": "Tongan pa’anga",
        "displayName-count-other": "Tongan pa’angaa",
        symbol: "TOP",
        "symbol-alt-narrow": "TOP"
      },
      TPE: {
        displayName: "Timorin escudo",
        "displayName-count-one": "Timorin escudo",
        "displayName-count-other": "Timorin escudoa",
        symbol: "TPE"
      },
      TRL: {
        displayName: "Turkin liira (1922–2005)",
        "displayName-count-one": "Turkin liira (1922–2005)",
        "displayName-count-other": "Turkin liiraa (1922–2005)",
        symbol: "TRL"
      },
      TRY: {
        displayName: "Turkin liira",
        "displayName-count-one": "Turkin liira",
        "displayName-count-other": "Turkin liiraa",
        symbol: "TRY",
        "symbol-alt-narrow": "TRY",
        "symbol-alt-variant": "TL"
      },
      TTD: {
        displayName: "Trinidadin ja Tobagon dollari",
        "displayName-count-one": "Trinidadin ja Tobagon dollari",
        "displayName-count-other": "Trinidadin ja Tobagon dollaria",
        symbol: "TTD",
        "symbol-alt-narrow": "TTD"
      },
      TWD: {
        displayName: "Taiwanin uusi dollari",
        "displayName-count-one": "Taiwanin uusi dollari",
        "displayName-count-other": "Taiwanin uutta dollaria",
        symbol: "TWD",
        "symbol-alt-narrow": "TWD"
      },
      TZS: {
        displayName: "Tansanian šillinki",
        "displayName-count-one": "Tansanian šillinki",
        "displayName-count-other": "Tansanian šillinkiä",
        symbol: "TZS"
      },
      UAH: {
        displayName: "Ukrainan hryvnia",
        "displayName-count-one": "Ukrainan hryvnia",
        "displayName-count-other": "Ukrainan hryvniaa",
        symbol: "UAH",
        "symbol-alt-narrow": "UAH"
      },
      UAK: {
        displayName: "Ukrainan karbovanetz",
        "displayName-count-one": "Ukrainan karbovanetz",
        "displayName-count-other": "Ukrainan karbovanetzia",
        symbol: "UAK"
      },
      UGS: {
        displayName: "Ugandan šillinki (1966–1987)",
        "displayName-count-one": "Ugandan šillinki (1966–1987)",
        "displayName-count-other": "Ugandan šillinkiä (1966–1987)",
        symbol: "UGS"
      },
      UGX: {
        displayName: "Ugandan šillinki",
        "displayName-count-one": "Ugandan šillinki",
        "displayName-count-other": "Ugandan šillinkiä",
        symbol: "UGX"
      },
      USD: {
        displayName: "Yhdysvaltain dollari",
        "displayName-count-one": "Yhdysvaltain dollari",
        "displayName-count-other": "Yhdysvaltain dollaria",
        symbol: "$",
        "symbol-alt-narrow": "$"
      },
      USN: {
        displayName: "Yhdysvaltain dollari (seuraava päivä)",
        "displayName-count-one": "Yhdysvaltain dollari (seuraava päivä)",
        "displayName-count-other": "Yhdysvaltain dollaria (seuraava päivä)",
        symbol: "USN"
      },
      USS: {
        displayName: "Yhdysvaltain dollari (sama päivä)",
        "displayName-count-one": "Yhdysvaltain dollari (sama päivä)",
        "displayName-count-other": "Yhdysvaltain dollaria (sama päivä)",
        symbol: "USS"
      },
      UYI: {
        displayName: "Uruguayn peso en unidades indexadas",
        "displayName-count-one": "Uruguayn peso en unidades indexadas",
        "displayName-count-other": "Uruguayn pesoa en unidades indexadas",
        symbol: "UYI"
      },
      UYP: {
        displayName: "Uruguayn peso (1975–1993)",
        "displayName-count-one": "Uruguayn peso (1975–1993)",
        "displayName-count-other": "Uruguayn pesoa (1975–1993)",
        symbol: "UYP"
      },
      UYU: {
        displayName: "Uruguayn peso",
        "displayName-count-one": "Uruguayn peso",
        "displayName-count-other": "Uruguayn pesoa",
        symbol: "UYU",
        "symbol-alt-narrow": "UYU"
      },
      UYW: {
        displayName: "Uruguayn nimellinen palkkaindeksiyksikkö",
        "displayName-count-one": "Uruguayn nimellinen palkkaindeksiyksikkö",
        "displayName-count-other": "Uruguayn nimellistä palkkaindeksiyksikköä",
        symbol: "UYW"
      },
      UZS: {
        displayName: "Uzbekistanin som",
        "displayName-count-one": "Uzbekistanin som",
        "displayName-count-other": "Uzbekistanin somia",
        symbol: "UZS"
      },
      VEB: {
        displayName: "Venezuelan bolívar (1871–2008)",
        "displayName-count-one": "Venezuelan bolivar (1871–2008)",
        "displayName-count-other": "Venezuelan bolivaria (1871–2008)",
        symbol: "VEB"
      },
      VED: {
        displayName: "VED",
        symbol: "VED"
      },
      VEF: {
        displayName: "Venezuelan bolívar (2008–2018)",
        "displayName-count-one": "Venezuelan bolívar (2008–2018)",
        "displayName-count-other": "Venezuelan bolívaria (2008–2018)",
        symbol: "VEF",
        "symbol-alt-narrow": "VEF"
      },
      VES: {
        displayName: "Venezuelan suvereeni bolívar",
        "displayName-count-one": "Venezuelan suvereeni bolívar",
        "displayName-count-other": "Venezuelan suvereenia bolívaria",
        symbol: "VES"
      },
      VND: {
        displayName: "Vietnamin dong",
        "displayName-count-one": "Vietnamin dong",
        "displayName-count-other": "Vietnamin dongia",
        symbol: "VND",
        "symbol-alt-narrow": "VND"
      },
      VNN: {
        displayName: "Vietnamin dong (1978–1985)",
        "displayName-count-one": "Vietnamin dong (1978–1985)",
        "displayName-count-other": "Vietnamin dongia (1978–1985)",
        symbol: "VNN"
      },
      VUV: {
        displayName: "Vanuatun vatu",
        "displayName-count-one": "Vanuatun vatu",
        "displayName-count-other": "Vanuatun vatua",
        symbol: "VUV"
      },
      WST: {
        displayName: "Samoan tala",
        "displayName-count-one": "Samoan tala",
        "displayName-count-other": "Samoan talaa",
        symbol: "WST"
      },
      XAF: {
        displayName: "CFA-frangi BEAC",
        "displayName-count-one": "CFA-frangi BEAC",
        "displayName-count-other": "CFA-frangia BEAC",
        symbol: "FCFA"
      },
      XAG: {
        displayName: "hopea",
        "displayName-count-one": "troy-unssi hopeaa",
        "displayName-count-other": "troy-unssia hopeaa",
        symbol: "XAG"
      },
      XAU: {
        displayName: "kulta",
        "displayName-count-one": "troy-unssi kultaa",
        "displayName-count-other": "troy-unssia kultaa",
        symbol: "XAU"
      },
      XBA: {
        displayName: "EURCO",
        "displayName-count-one": "EURCO",
        "displayName-count-other": "EURCO’a",
        symbol: "XBA"
      },
      XBB: {
        displayName: "Euroopan rahayksikkö (EMU)",
        "displayName-count-one": "Euroopan rahayksikkö (EMU)",
        "displayName-count-other": "Euroopan rahayksikköä (EMU)",
        symbol: "XBB"
      },
      XBC: {
        displayName: "EUA (XBC)",
        "displayName-count-one": "EUA (XBC)",
        "displayName-count-other": "EUA’ta (XBC)",
        symbol: "XBC"
      },
      XBD: {
        displayName: "EUA (XBD)",
        "displayName-count-one": "EUA (XBD)",
        "displayName-count-other": "EUA’ta (XBD)",
        symbol: "XBD"
      },
      XCD: {
        displayName: "Itä-Karibian dollari",
        "displayName-count-one": "Itä-Karibian dollari",
        "displayName-count-other": "Itä-Karibian dollaria",
        symbol: "XCD",
        "symbol-alt-narrow": "XCD"
      },
      XDR: {
        displayName: "erityisnosto-oikeus (SDR)",
        "displayName-count-one": "erityisnosto-oikeus (SDR)",
        "displayName-count-other": "erityisnosto-oikeutta (SDR)",
        symbol: "XDR"
      },
      XEU: {
        displayName: "Euroopan valuuttayksikkö (ECU)",
        "displayName-count-one": "Euroopan valuuttayksikkö (ECU)",
        "displayName-count-other": "Euroopan valuuttayksikköä (ECU)",
        symbol: "XEU"
      },
      XFO: {
        displayName: "Ranskan kultafrangi",
        "displayName-count-one": "Ranskan kultafrangi",
        "displayName-count-other": "Ranskan kultafrangia",
        symbol: "XFO"
      },
      XFU: {
        displayName: "Ranskan UIC-frangi",
        "displayName-count-one": "Ranskan UIC-frangi",
        "displayName-count-other": "Ranskan UIC-frangia",
        symbol: "XFU"
      },
      XOF: {
        displayName: "CFA-frangi BCEAO",
        "displayName-count-one": "CFA-frangi BCEAO",
        "displayName-count-other": "CFA-frangia BCEAO",
        symbol: "F CFA"
      },
      XPD: {
        displayName: "palladium",
        "displayName-count-one": "troy-unssi palladiumia",
        "displayName-count-other": "troy-unssia palladiumia",
        symbol: "XPD"
      },
      XPF: {
        displayName: "CFP-frangi",
        "displayName-count-one": "CFP-frangi",
        "displayName-count-other": "CFP-frangia",
        symbol: "XPF"
      },
      XPT: {
        displayName: "platina",
        "displayName-count-one": "troy-unssi platinaa",
        "displayName-count-other": "troy-unssia platinaa",
        symbol: "XPT"
      },
      XRE: {
        displayName: "RINET-rahastot",
        "displayName-count-one": "RINET-rahastoyksikkö",
        "displayName-count-other": "RINET-rahastoyksikköä",
        symbol: "XRE"
      },
      XSU: {
        displayName: "etelä-amerikkalaisen ALBA:n laskentayksikkö sucre",
        "displayName-count-one": "sucre",
        "displayName-count-other": "sucrea",
        symbol: "XSU"
      },
      XTS: {
        displayName: "testaustarkoitukseen varattu valuuttakoodi",
        "displayName-count-one": "testaustarkoitukseen varattu valuuttakoodi",
        "displayName-count-other": "testaustarkoitukseen varattua valuuttakoodia",
        symbol: "XTS"
      },
      XUA: {
        displayName: "afrikkalainen AfDB-laskentayksikkö",
        "displayName-count-one": "AfDB-laskentayksikkö",
        "displayName-count-other": "AfDB-laskentayksikköä",
        symbol: "XUA"
      },
      XXX: {
        displayName: "tuntematon rahayksikkö",
        "displayName-count-one": "tuntematon rahayksikkö",
        "displayName-count-other": "tuntematonta rahayksikköä",
        symbol: "XXX"
      },
      YDD: {
        displayName: "Jemenin dinaari",
        "displayName-count-one": "Jemenin dinaari",
        "displayName-count-other": "Jemenin dinaaria",
        symbol: "YDD"
      },
      YER: {
        displayName: "Jemenin rial",
        "displayName-count-one": "Jemenin rial",
        "displayName-count-other": "Jemenin rialia",
        symbol: "YER"
      },
      YUD: {
        displayName: "Jugoslavian kova dinaari (1966–1990)",
        "displayName-count-one": "Jugoslavian kova dinaari (1966–1990)",
        "displayName-count-other": "Jugoslavian kovaa dinaaria (1966–1990)",
        symbol: "YUD"
      },
      YUM: {
        displayName: "Jugoslavian uusi dinaari (1994–2002)",
        "displayName-count-one": "Jugoslavian uusi dinaari (1994–2002)",
        "displayName-count-other": "Jugoslavian uutta dinaaria (1994–2002)",
        symbol: "YUM"
      },
      YUN: {
        displayName: "Jugoslavian vaihdettava dinaari (1990–1992)",
        "displayName-count-one": "Jugoslavian vaihdettava dinaari (1990–1992)",
        "displayName-count-other": "Jugoslavian vaihdettavaa dinaaria (1990–1992)",
        symbol: "YUN"
      },
      YUR: {
        displayName: "Jugoslavian uudistettu dinaari (1992–1993)",
        "displayName-count-one": "Jugoslavian uudistettu dinaari (1992–1993)",
        "displayName-count-other": "Jugoslavian uudistettua dinaaria (1992–1993)",
        symbol: "YUR"
      },
      ZAL: {
        displayName: "Etelä-Afrikan rahoitusrandi",
        "displayName-count-one": "Etelä-Afrikan rahoitusrandi",
        "displayName-count-other": "Etelä-Afrikan rahoitusrandia",
        symbol: "ZAL"
      },
      ZAR: {
        displayName: "Etelä-Afrikan randi",
        "displayName-count-one": "Etelä-Afrikan randi",
        "displayName-count-other": "Etelä-Afrikan randia",
        symbol: "ZAR",
        "symbol-alt-narrow": "ZAR"
      },
      ZMK: {
        displayName: "Sambian kwacha (1968–2012)",
        "displayName-count-one": "Sambian kwacha (1968–2012)",
        "displayName-count-other": "Sambian kwachaa (1968–2012)",
        symbol: "ZMK"
      },
      ZMW: {
        displayName: "Sambian kwacha",
        "displayName-count-one": "Sambian kwacha",
        "displayName-count-other": "Sambian kwachaa",
        symbol: "ZMW",
        "symbol-alt-narrow": "ZMW"
      },
      ZRN: {
        displayName: "Zairen uusi zaire (1993–1998)",
        "displayName-count-one": "Zairen uusi zaire (1993–1998)",
        "displayName-count-other": "Zairen uutta zairea (1993–1998)",
        symbol: "ZRN"
      },
      ZRZ: {
        displayName: "Zairen zaire (1971–1993)",
        "displayName-count-one": "Zairen zaire (1971–1993)",
        "displayName-count-other": "Zairen zairea (1971–1993)",
        symbol: "ZRZ"
      },
      ZWD: {
        displayName: "Zimbabwen dollari (1980–2008)",
        "displayName-count-one": "Zimbabwen dollari (1980–2008)",
        "displayName-count-other": "Zimbabwen dollaria (1980–2008)",
        symbol: "ZWD"
      },
      ZWL: {
        displayName: "Zimbabwen dollari (2009)",
        "displayName-count-one": "Zimbabwen dollari (2009)",
        "displayName-count-other": "Zimbabwen dollaria (2009)",
        symbol: "ZWL"
      },
      ZWR: {
        displayName: "Zimbabwen dollari (2008)",
        "displayName-count-one": "Zimbabwen dollari (2008)",
        "displayName-count-other": "Zimbabwen dollaria (2008)",
        symbol: "ZWR"
      }
    },
    localeCurrency: "EUR"
  },
  calendar: {
    patterns: {
      d: "d.M.y",
      D: "cccc d. MMMM y",
      m: "d. MMM",
      M: "d. MMMM",
      y: "LLL y",
      Y: "LLLL y",
      F: "cccc d. MMMM y H.mm.ss",
      g: "d.M.y H.mm",
      G: "d.M.y H.mm.ss",
      t: "H.mm",
      T: "H.mm.ss",
      s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
      u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'"
    },
    dateTimeFormats: {
      full: "{1} 'klo' {0}",
      long: "{1} 'klo' {0}",
      medium: "{1} 'klo' {0}",
      short: "{1} {0}",
      availableFormats: {
        Bh: "h B",
        Bhm: "h.mm B",
        Bhms: "h.mm.ss B",
        d: "d",
        E: "ccc",
        EBhm: "E h.mm B",
        EBhms: "E h.mm.ss B",
        Ed: "E d.",
        Ehm: "E h.mm a",
        EHm: "E H.mm",
        Ehms: "E h.mm.ss a",
        EHms: "E H.mm.ss",
        Gy: "y G",
        GyMd: "M.d.y G",
        GyMMM: "LLL y G",
        GyMMMd: "d. MMM y G",
        GyMMMEd: "E d. MMM y G",
        GyMMMMd: "d. MMMM y G",
        GyMMMMEd: "E d. MMMM y G",
        h: "h a",
        H: "H",
        hm: "h.mm a",
        Hm: "H.mm",
        hms: "h.mm.ss a",
        Hms: "H.mm.ss",
        hmsv: "h.mm.ss a v",
        Hmsv: "H.mm.ss v",
        hmv: "h.mm a v",
        Hmv: "H.mm v",
        M: "L",
        Md: "d.M.",
        MEd: "E d.M.",
        MMM: "LLL",
        MMMd: "d. MMM",
        MMMEd: "ccc d. MMM",
        MMMMd: "d. MMMM",
        MMMMEd: "ccc d. MMMM",
        "MMMMW-count-one": "LLLL'n' W. 'viikko'",
        "MMMMW-count-other": "LLLL'n' W. 'viikko'",
        ms: "m.ss",
        y: "y",
        yM: "L.y",
        yMd: "d.M.y",
        yMEd: "E d.M.y",
        yMM: "M.y",
        yMMM: "LLL y",
        yMMMd: "d. MMM y",
        yMMMEd: "E d. MMM y",
        yMMMM: "LLLL y",
        yMMMMccccd: "cccc d. MMMM y",
        yMMMMd: "d. MMMM y",
        yMMMMEd: "E d. MMMM y",
        yQQQ: "QQQ y",
        yQQQQ: "QQQQ y",
        "yw-count-one": "'vuoden' Y 'viikko' w",
        "yw-count-other": "'vuoden' Y 'viikko' w"
      }
    },
    timeFormats: {
      full: "H.mm.ss zzzz",
      long: "H.mm.ss z",
      medium: "H.mm.ss",
      short: "H.mm"
    },
    dateFormats: {
      full: "cccc d. MMMM y",
      long: "d. MMMM y",
      medium: "d.M.y",
      short: "d.M.y"
    },
    days: {
      format: {
        abbreviated: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        narrow: ["S", "M", "T", "K", "T", "P", "L"],
        short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
      },
      "stand-alone": {
        abbreviated: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        narrow: ["S", "M", "T", "K", "T", "P", "L"],
        short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
      }
    },
    months: {
      format: {
        abbreviated: ["tammik.", "helmik.", "maalisk.", "huhtik.", "toukok.", "kesäk.", "heinäk.", "elok.", "syysk.", "lokak.", "marrask.", "jouluk."],
        narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
        wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta", "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
      },
      "stand-alone": {
        abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],
        narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
        wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
      }
    },
    quarters: {
      format: {
        abbreviated: ["1. nelj.", "2. nelj.", "3. nelj.", "4. nelj."],
        narrow: ["1", "2", "3", "4"],
        wide: ["1. neljännes", "2. neljännes", "3. neljännes", "4. neljännes"]
      },
      "stand-alone": {
        abbreviated: ["1. nelj.", "2. nelj.", "3. nelj.", "4. nelj."],
        narrow: ["1", "2", "3", "4"],
        wide: ["1. neljännes", "2. neljännes", "3. neljännes", "4. neljännes"]
      }
    },
    dayPeriods: {
      format: {
        abbreviated: {
          midnight: "keskiyöllä",
          am: "ap.",
          noon: "keskip.",
          pm: "ip.",
          morning1: "aamulla",
          morning2: "aamup.",
          afternoon1: "iltap.",
          evening1: "illalla",
          night1: "yöllä"
        },
        narrow: {
          midnight: "ky.",
          am: "ap.",
          noon: "kp.",
          pm: "ip.",
          morning1: "aamulla",
          morning2: "ap.",
          afternoon1: "ip.",
          evening1: "illalla",
          night1: "yöllä"
        },
        wide: {
          midnight: "keskiyöllä",
          am: "ap.",
          noon: "keskipäivällä",
          pm: "ip.",
          morning1: "aamulla",
          morning2: "aamupäivällä",
          afternoon1: "iltapäivällä",
          evening1: "illalla",
          night1: "yöllä"
        }
      },
      "stand-alone": {
        abbreviated: {
          midnight: "keskiyö",
          am: "ap.",
          noon: "keskip.",
          pm: "ip.",
          morning1: "aamu",
          morning2: "aamup.",
          afternoon1: "iltap.",
          evening1: "ilta",
          night1: "yö"
        },
        narrow: {
          midnight: "ky.",
          am: "ap.",
          noon: "kp.",
          pm: "ip.",
          morning1: "aamu",
          morning2: "ap.",
          afternoon1: "ip.",
          evening1: "ilta",
          night1: "yö"
        },
        wide: {
          midnight: "keskiyö",
          am: "ap.",
          noon: "keskipäivä",
          pm: "ip.",
          morning1: "aamu",
          morning2: "aamupäivä",
          afternoon1: "iltapäivä",
          evening1: "ilta",
          night1: "yö"
        }
      }
    },
    eras: {
      format: {
        wide: {
          "0": "ennen Kristuksen syntymää",
          "1": "jälkeen Kristuksen syntymän",
          "0-alt-variant": "ennen ajanlaskun alkua",
          "1-alt-variant": "jälkeen ajanlaskun alun"
        },
        abbreviated: {
          "0": "eKr.",
          "1": "jKr.",
          "0-alt-variant": "eaa.",
          "1-alt-variant": "jaa."
        },
        narrow: {
          "0": "eKr",
          "1": "jKr",
          "0-alt-variant": "eaa",
          "1-alt-variant": "jaa"
        }
      }
    },
    gmtFormat: "UTC{0}",
    gmtZeroFormat: "UTC",
    dateFields: {
      era: {
        wide: "aikakausi",
        short: "aikakausi",
        narrow: "aikakausi"
      },
      year: {
        wide: "vuosi",
        short: "v",
        narrow: "v"
      },
      quarter: {
        wide: "neljännesvuosi",
        short: "neljännes",
        narrow: "nelj."
      },
      month: {
        wide: "kuukausi",
        short: "kk",
        narrow: "kk"
      },
      week: {
        wide: "viikko",
        short: "vk",
        narrow: "vk"
      },
      weekOfMonth: {
        wide: "kuukauden viikko",
        short: "kuukauden vk",
        narrow: "kuukauden vk"
      },
      day: {
        wide: "päivä",
        short: "pv",
        narrow: "pv"
      },
      dayOfYear: {
        wide: "vuodenpäivä",
        short: "vuodenpv",
        narrow: "vuodenpv"
      },
      weekday: {
        wide: "viikonpäivä",
        short: "viikonpäivä",
        narrow: "viikonpäivä"
      },
      weekdayOfMonth: {
        wide: "kuukauden viikonpäivä",
        short: "kuukauden vk päivä",
        narrow: "kuukauden vk päivä"
      },
      dayperiod: {
        short: "vuorokaudenaika",
        wide: "vuorokaudenaika",
        narrow: "vuorokaudenaika"
      },
      hour: {
        wide: "tunti",
        short: "t",
        narrow: "t"
      },
      minute: {
        wide: "minuutti",
        short: "min",
        narrow: "min"
      },
      second: {
        wide: "sekunti",
        short: "s",
        narrow: "s"
      },
      zone: {
        wide: "aikavyöhyke",
        short: "aikavyöhyke",
        narrow: "aikavyöhyke"
      },
      millisecond: {
        narrow: "ms",
        short: "ms",
        wide: "millisekunti"
      }
    }
  },
  firstDay: 1,
  weekendRange: {
    start: 6,
    end: 0
  },
  likelySubtags: {
    fi: "fi-Latn-FI"
  }
});